type Color = { font: string; background: string };

const colors: Array<Color> = [
  { font: '#FE4CA2', background: '#A6005B' },
  { font: '#A62F00', background: '#FF7226' },
  { font: '#A66600', background: '#FFB926' },
  { font: '#4E6600', background: '#C3E500' },
  { font: '#108C00', background: '#46E522' },
  { font: '#009499', background: '#00E5E2' },
  { font: '#0058A6', background: '#33ADFF' },
  { font: '#4026BF', background: '#737EFF' },
  { font: '#5B0F99', background: '#B773FF' },
];

const defaultColor: Color = { font: '#466EC3', background: '#C2EDFF' };

const numberFromText = (text: string): number => {
  const charCodes = text
    .split('')
    .map((char) => char.charCodeAt(0))
    .join('');

  return parseInt(charCodes, 10);
};

export const defaultAvatarColorsGenerator = (text: string): Color =>
  text ? colors[numberFromText(text) % colors.length] : defaultColor;
